import React, { useEffect, useMemo, useState } from "react";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import PopupWrapper from "../../../components/PopupWrapper";
import ErrorBoundary from "../../../components/ErrorBoundary";
import FormBox from "../../../components/FormBox/FormBox";
import useBorrowerDashboardTwo from "./apis/useBorrowerDashboardTwo";
import {
  ExistingPayoffRequestModal,
  LoadingButton,
} from "../../../Utils/CustomComponent";
import urls from "../../../Utils/urls";
import { useSelector } from "react-redux";
import axios from "../../../axios";
import { toast } from "react-toastify";
import { commonToast } from "../../../Utils";
import moment from "moment";
import useBorowerLoanDetail from "../../../hooks/useBorowerLoanDetail";
import { Placeholder } from "react-bootstrap";

const RequestPayOffModal = ({ payOffModal, setPayOffModal, refreshTable }) => {
  const [disableBtn, setDisableBtn] = useState(false);
  const [minDate, setMinDate] = useState(null);
  const [maxDate, setMaxDate] = useState(null);
  const [duplicate, setDuplicate] = useState(false);
  const [duplicateDetails, setDuplicateDetails] = useState(null);
  const selectedAccount = useSelector((state) => state.account.selectedAccount);
  const { activeAccountList } = useBorrowerDashboardTwo();
  const email = useSelector(
    (state) => state.RS_Authentication.user.details.email,
  );
  const masqueradeEmail = useSelector(
    (state) => state.RS_Authentication.masquerade,
  );

  const createPayoffFormSchema = {
    resolver: yupResolver(
      Yup.object().shape({
        loan_number: Yup.string().required("Loan number is required!"),
        payoff_good_through_date: Yup.string().required(
          "Payoff Good Through Date is required!",
        ),
        cema: Yup.string().required("This field is required!"),
      }),
    ),
  };
  const {
    handleSubmit,
    register,
    watch,
    setValue,
    formState: { errors },
    reset,
  } = useForm(createPayoffFormSchema);

  const loanNumber = watch("loan_number");
  const property_address = watch("property_address");
  const payoff_good_through_date = watch("payoff_good_through_date");
  // const demand_expiration_date = payoff_good_through_date
  //   ? new Date(moment(payoff_good_through_date).add(7, "days"))
  //   : null;
  const userDetails = JSON.parse(localStorage.getItem("accessed_user"));
  const options =
    activeAccountList?.map((el) => ({
      label: el.displayValue,
      value: el.displayValue,
      recid: el.value,
    })) || [];

  const selectedLoanRecid = options?.filter(
    (el) => el.label === loanNumber,
  )?.[0]?.recid;

  const { loanDetails, status } = useBorowerLoanDetail(selectedLoanRecid);

  useEffect(() => {
    if (selectedLoanRecid && loanDetails?.loanTerm?.loanheader2) {
      const property =
        loanDetails?.loanTerm?.loanheader2?.split("Property Address:")?.[1];
      setValue("property_address", property);
    }
  }, [selectedLoanRecid, loanDetails?.loanTerm?.loanheader2]);

  useEffect(() => {
    async function getCurrentDate() {
      try {
        const res = await axios.get(urls.borrower.currentDateNTime);
        setMinDate(res?.data?.datetime);

        const maxAllowedDate = new Date(res?.data?.datetime);
        maxAllowedDate.setDate(maxAllowedDate.getDate() + 30);

        setMaxDate(maxAllowedDate);
      } catch (error) {
        console.error(error);
      }
    }

    getCurrentDate();
  }, []);

  const demandExpirationDate = useMemo(() => {
    return payoff_good_through_date
      ? new Date(moment(payoff_good_through_date).add(7, "days"))
      : null;
  }, [payoff_good_through_date]);

  useEffect(() => {
    setValue("demand_expiration_date", demandExpirationDate);
  }, [demandExpirationDate]);

  // useEffect(() => {
  //   console.log(payoff_good_through_date);
  //   const demand_expiration_date = payoff_good_through_date
  //     ? new Date(moment(payoff_good_through_date).add(7, "days"))
  //     : null;
  //   setValue("demand_expiration_date", demand_expiration_date);
  // }, [payoff_good_through_date, setValue]);

  function closeModal() {
    setPayOffModal(false);
    reset({
      remarks: "",
    });
  }

  async function onSubmit(data) {
    setDisableBtn(true);
    const id = toast.loading("Creating payoff request");

    const res = await axios.get(urls.borrower.currentDateNTime);

    const now = moment
      .tz(res?.data?.datetime, "America/Los_Angeles")
      .format("MM/DD/YYYY");

    // data.subject = `PO demand good thru ${data.payoff_good_through_date}  ${data.loan_number}`;
    // data.incident_description = `PO demand good thru ${data.payoff_good_through_date}  ${data.loan_number}`;
    // data.category_id = "38298369716579832700126775148817329199";
    // data.account = selectedAccount?.value;
    // data.department_id = "2";
    // data.sub_category_id = "42888371779545365743097884625194376948";
    // data.user_id = `${userDetails.user_id}`;
    // data.contact_email = userDetails.email;
    // data.status_id = "1";
    // data.role_type = selectedRole;
    // data.severity_id = "";
    // data.urgency_id = "";

    const payload = {
      loanrecid: selectedLoanRecid,
      loan_number: data.loan_number,
      payoff_good_through_date: data.payoff_good_through_date,
      demand_expiration_date: moment(data.demand_expiration_date).format(
        "MM/DD/YYYY",
      ),
      requesting_party_email: userDetails.email,
      source: "Loanlinq",
      payoff_requested_date: now,
      remarks: data.remarks,
      role: "Borrower",
      logger_email:
        masqueradeEmail?.isIt == true
          ? masqueradeEmail?.p_logged_in_email
          : email,
      cema: data.cema,
    };

    const headers = {
      "Content-Type": "application/json",
      Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
      // maxBodyLength: Infinity,
    };
    axios
      .post(urls.support.createPayoff, payload, { headers })
      .then((response) => {
        if (
          response?.data?.message?.includes(
            "Active Payoff Request is already in process for this Loan",
          )
        ) {
          setDuplicate(true);
          setDuplicateDetails({ ...response?.data, loanNumber: loanNumber });
          toast.update(id, {
            render: "Active Payoff Request is already in process for this Loan",
            type: "info",
            isLoading: false,
            ...commonToast,
          });
          setDisableBtn(false);
          closeModal();
        } else {
          closeModal();
          toast.update(id, {
            render: "Payoff Request Created",
            type: "success",
            isLoading: false,
            ...commonToast,
          });
          refreshTable();
          setDisableBtn(false);
        }
      })
      .catch((error) => {
        console.error(error);
        toast.update(id, {
          render: "SOME ERROR OCCURED",
          type: "error",
          isLoading: false,
          ...commonToast,
        });
        setDisableBtn(false);
      });
  }

  return (
    <div>
      <PopupWrapper
        Component={
          <ErrorBoundary>
            <div>
              <FormBox
                options={payOffArr(
                  options,
                  demandExpirationDate,
                  minDate,
                  status,
                  property_address,
                  maxDate
                )}
                register={register}
                watch={watch}
                setValue={setValue}
                errors={errors}
              />
              <div>
                <LoadingButton
                  type="button"
                  className="btn btn-primary mt-3 text-white"
                  onClick={handleSubmit(onSubmit)}
                  title={"Request"}
                  disabled={disableBtn}
                  loading={disableBtn}
                />
              </div>
            </div>
          </ErrorBoundary>
        }
        title="Request Payoff"
        extraClass="width-800"
        toShow={payOffModal}
        closeEventHandler={closeModal}
      />
      <ExistingPayoffRequestModal
        show={duplicate}
        onClose={() => setDuplicate(false)}
        loanNumber={duplicateDetails?.loanNumber}
        requestDate={duplicateDetails?.request_date}
        payoffRequestId={duplicateDetails?.request_number}
      />
    </div>
  );
};

export default RequestPayOffModal;

const payOffArr = (
  options,
  demandExpirationDate,
  minDate,
  status,
  property_address,
  maxDate
) => {
  return [
    {
      title: "Loan Number",
      field: "loan_number",
      type: "select",
      className: "col-12 py-4",
      options: options,
    },
    {
      title: "Property Address",
      field: "property_address",
      type: "text",
      className: "col-12 py-4",
      disable: true,
      display: status === "loading" || !property_address ? "hidden" : "",
    },
    {
      type: "content",
      content: (
        <Placeholder
          animation="wave"
          as="div"
          className="col-6 form-control input-lg bg-grey input-lg p-4"
        >
          <Placeholder xs={6} bg="grey" size="lg" className="p-5" />
        </Placeholder>
      ),
      display: status === "loading" ? "" : "hidden",
    },
    {
      title: "Payoff Good Through Date",
      field: "payoff_good_through_date",
      type: "date",
      className: "col-6 py-4",
      minDate: minDate,
      maxDate: maxDate,
      filter: true,
    },
    {
      title: "Demand Expiration Date",
      field: "demand_expiration_date",
      type: "date",
      className: "col-6 py-4",
      disable: true,
      value: demandExpirationDate,
    },
    {
      title: "CEMA",
      field: "cema",
      type: "select",
      className: "col-6 py-4",
      options: [
        { label: "Yes", value: "Y" },
        { label: "No", value: "N" },
      ],
    },
    {
      title: "Remarks (Optional)",
      field: "remarks",
      type: "textarea",
      className: "col-6 py-4",
      rows: 1,
    },
  ];
};
